import { Typography, useTheme, Grid, Tooltip, Box } from "@mui/material";
import Iconify from "~src/components/Iconify";
import usePermissions from "~src/hooks/usePermissions";

type GridRowProps = {
  label: string;
  value: React.ReactNode;
};

export default function GridRow({ label, value }: GridRowProps) {
  const { premiumCommunity } = usePermissions();
  const theme = useTheme();
  return (
    <Grid 
      size={{ xs: 12 }}
      sx={{
        display: "flex",
        justifyContent: "space-between",
        mx: 1,
        borderBottom: label === "Avg. Product Price" ? 0 : 1,
        borderColor: theme.palette.grey[300],
      }}
    >
      <Grid size={{ sm: 6 }}>
        <Typography
          sx={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            color: theme.palette.grey[500],
          }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid size={{ sm: 6 }}
        sx={{
          textAlign: "right",
        }}
      >
        <Typography
          sx={{
            wordBreak: "break-word",
            whiteSpace: "normal",
            color: theme.palette.grey[500],
          }}
        >
          {label === "Avg. Product Price" && "$ "}
          {!premiumCommunity && label === "Revenue Estimate" ? (
            <Tooltip title="Upgrade to see revenue estimates">
              <Box>
                <Iconify
                  icon={"ant-design:lock-filled"}
                  width={25}
                  height={25}
                />
              </Box>
            </Tooltip>
          ) : label === "FB Ads Active" || label === "Year of launch" ? (
            value
          ) : label === "Est. Monthly Revenue" ? (
            `$${
              typeof value === "number"
                ? Math.round(value).toLocaleString()
                : value?.toString()
            }`
          ) : (
            value?.toLocaleString()
          )}
        </Typography>
      </Grid>
    </Grid>
  );
}
